import styled from 'styled-components';
import { Row, Modal } from 'antd';

export const StepsContainer = styled(Row)`
	border-radius: 1rem;
	padding: 2rem !important;
	background-color: #f8f8f8;

	@media (min-width: 1600px) {
		padding: 2rem 3rem !important;
	}
`;

export const ModalContainer = styled(Modal)`
	.ant-modal-content {
		border-radius: 1rem !important;
	}

	.ant-modal-body {
		padding: 50px;
	}
`;
